import { Localization } from "../../../common/localizable-component";
import { TabsLocalization } from "./tabs-types";

export const TABS_LOCALIZATION: Localization<TabsLocalization> = {
  en: {
    updatedContent: "Updated content"
  },
  de: {
    updatedContent: "Aktualisierter Inhalt"
  },
  sv: {
    updatedContent: "Uppdaterat innehåll"
  },
  nl: {
    updatedContent: "Bijgewerkte inhoud"
  },
  it: {
    updatedContent: "Contenuto aggiornato"
  },
  hu: {
    updatedContent: "Frissített tartalom"
  },
  da: {
    updatedContent: "Opdateret indhold"
  },
  fr: {
    updatedContent: "Contenu actualisé"
  },
  es: {
    updatedContent: "Contenido actualizado"
  },
  pl: {
    updatedContent: "Zaktualizowana zawartość"
  },
  ro: {
    updatedContent: "Conținut actualizat"
  },
  hr: {
    updatedContent: "Ažurirani sadržaj"
  },
  cs: {
    updatedContent: "Aktualizovaný obsah"
  },
  sl: {
    updatedContent: "Posodobljeno vsebino"
  }
};
